var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.keyMain, staticClass: "container-fluid" },
    [
      _vm.mercurialesChargees
        ? _c("BarreFiltres", {
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          })
        : _vm._e(),
      _vm.afficherActions
        ? _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          })
        : _vm._e(),
      _c("ModalDuplicationFavoris", { ref: "modalDuplicationFavoris" }),
      _vm.mercurialesChargees
        ? _c("div", { attrs: { id: "mercuriales" } }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 text-center push-top-2rem" }, [
                _vm._v(_vm._s(_vm.filters.pg))
              ]),
              _c(
                "div",
                { staticClass: "col-12" },
                [_c("transition", { attrs: { name: "fade", mode: "out-in" } })],
                1
              )
            ])
          ])
        : _c(
            "div",
            {
              staticClass: "bg-white",
              staticStyle: { "text-align": "center" }
            },
            [
              _c("img", {
                attrs: {
                  alt: "en attente",
                  src: "/assets/images/spinners/cooking-blue-court.gif"
                }
              })
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }